import { useEffect, useState, useCallback, use } from "react";
import { useSelector, useDispatch } from "react-redux";
import HeaderCard from "../Component/HeaderCard";
import { useNavigate } from "react-router-dom";
import StudentChapter from "./StudentChapter";
import api from "../utils/api";
import ExtraChapter from "./ExtraChapter";
import { extraLessonReducer } from "../redux/slice/extralessonSlice";

function StudentDetail() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeLevel, setActiveLevel] = useState("Chapters");
  const [selectClass, setSelectClass] = useState(2);
  const [activeClass, setActiveClass] = useState([]);
  const [allChapter, SetAllChapter] = useState([]);
  const [completedChapter, setCompletedChapter] = useState([]);
  const [studentForId, setStudentForId] = useState();
  const [selectedByClass, setSelectedByClass] = useState("");
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [activeExtra, setActiveExtra] = useState([]);
  const [extraStatus, setExtraStatus] = useState([]);
  const [selectedExtra, setSelectedExtra] = useState(null);
  // const [choiceClass, setChoiceClass] = useState(null);
  const [extraChapterStatus, setExtraChapterStatus] = useState([]);
  const studentId = useSelector((state) => state.studentDetailId.value);
  const selectClasses = useSelector((state) => state.selectClass.value);
  const user = JSON.parse(localStorage.getItem("postUser"));

  const userExtraScore = user.extrascore;
  const acitveClass = useSelector((state) => state.activeComponent.value);
  const fetchStudentInfo = useCallback(async () => {
    if (!studentId || !selectedByClass) {
      return;
    }
    setLoading(true);
    setError(null);
    try {
      // chapters ilgili istek - activeLevel kullan!
      if (activeLevel === "Chapters") {
        const response = await api.get("detailStudent", {
          params: {
            _id: studentId,
            className: selectedByClass,
          },
        });

        if (response.status === 200 && response.data) {
          setActiveClass(response.data.updatedIstatikArray || []);
          setCompletedChapter(response.data.studentTaskArray || []);
          SetAllChapter(response.data.classTaskArray || []);
          setStudentForId(response.data.studentId);
        }
      }

      // ödev ile ilgili istek
      else if (activeLevel === "Homeworks") {
        // API çağrınızı buraya ekleyin
      }

      // extra ile ilgili istek
      else if (activeLevel === "Extras") {
        try {
          const response = await api.get("get_extraScore", {
            params: { class_name: selectedByClass, id: studentId },
          });

          if (response.status === 200) {
            const matchingValue = response.data.result;
            setExtraChapterStatus(matchingValue);
            if (matchingValue) {
              // Tüm extra'ların durumlarını hesapla
              const extraStatusCounts = matchingValue.map((item) => {
                const extraStatusObje = [
                  item.true_false,
                  item.listen_find,
                  item.answer_question,
                  item.description,
                ];

                // Sadece true olanları say
                const trueCount = extraStatusObje.filter(
                  (value) => value === true,
                ).length;
                return trueCount;
              });

              // Birleştirme işlemi
              const extra_count = matchingValue.map((item, index) => {
                return {
                  ...item, // Objenin içindeki mevcut tüm özellikleri (name, picture vs.) koru
                  puan: extraStatusCounts[index], // Yeni bir özellik ekle ve değer dizisindeki karşılığını ver
                };
              });
              setActiveExtra(extra_count);
            }
          }
        } catch (error) {
          console.error("Extra bilgisi alınamadı:", error);
          setError(error.response?.data?.message || "Bir hata oluştu");
        }
      }
    } catch (error) {
      console.error("Öğrenci bilgisi alınamadı:", error);
      setError(error.response?.data?.message || "Bir hata oluştu");
    } finally {
      setLoading(false);
    }
  }, [studentId, selectedByClass, activeLevel]); // ← activeLevel dependency'e eklendi
  useEffect(() => {
    // contentValue boş veya tanımsız veya uzunluğu 0 ise ana sayfaya yönlendir
    if (!selectClasses || !studentId) {
      navigate("/");
    }
  }, [selectClasses, studentId]);

  useEffect(() => {
    if (selectClasses && selectClasses.className) {
      const className = selectClasses.className;
      if (className.includes("2") || acitveClass === 1) {
        setSelectedByClass("class 2");
      } else if (className.includes("3") || acitveClass === 2) {
        setSelectedByClass("class 3");
      } else if (className.includes("4") || acitveClass === 3) {
        setSelectedByClass("class 4");
      } else {
        setSelectedByClass("");
      }
    }
  }, [selectClasses]);
  useEffect(() => {
    if (selectedByClass) {
      fetchStudentInfo();
    }
  }, [selectedByClass, fetchStudentInfo]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleSelectChapter = (value) => {
    setSelectedUnit(value);
  };
  const handleSelectExtra = (value) => {
    setSelectedExtra(value);
    const selectedValue = extraChapterStatus.find(
      (item) => item.name === value,
    );
    if (selectedValue) {
      dispatch(extraLessonReducer(selectedValue));
    }
  };

  // const userExtraScore = user.extrascore;
  // const acitveClass = useSelector((state) => state.activeComponent.value);

  const levelSet = [
    { name: "Chapters", tr: "Bölümler" },
    { name: "Homeworks", tr: "Ödevler" },
    { name: "Extras", tr: "Extralar" },
    { name: "Exit", tr: "Çıkış" },
  ];
  // Sınıf seçimi işlevselliği
  // useEffect(() => {
  //   if (selectClasses && selectClasses.className) {
  //     const className = selectClasses.className;
  //     if (className.includes("2") || acitveClass === 1) {
  //       setSelectedByClass("class 2");
  //     } else if (className.includes("3") || acitveClass === 2) {
  //       setSelectedByClass("class 3");
  //     } else if (className.includes("4") || acitveClass === 3) {
  //       setSelectedByClass("class 4");
  //     } else {
  //       setSelectedByClass("");
  //     }
  //   }
  // }, [selectClasses]);
  // console.log(activeClass, "tutan değer");
  // Öğrenci bilgilerini çekme işlevi

  // useEffect(() => {
  //   if (selectedByClass) {
  //     fetchStudentInfo();
  //   }
  // }, [selectedByClass, fetchStudentInfo]);
  const TaskName = (value) => {
    if (!value) return "";

    const str = String(value);
    if (str.includes("_")) {
      const words = str.split("_");
      const capitalized = words.map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1),
      );
      return capitalized.join(" ");
    } else {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  };

  const handleLevelChange = (level) => {
    if (level === "Exit") {
      navigate("/");
      return;
    }

    setActiveLevel(level);
    setSelectedUnit(null);
    setSelectedExtra(null);
  };
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-xl">Yükleniyor...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-xl text-red-500">Hata: {error}</div>
      </div>
    );
  }

  return (
    <div className=" flex flex-col w-full gap-4">
      <div className="w-full">
        <div
          className="flex flex-col lg:flex-row gap-3 md:gap-4 max-w-8xl
       bg-yellow-500 w-full rounded-xl justify-between items-center px-2 py-3 lg:px-6 "
        >
          <div className="w-full md:w-auto flex flex-col">
            <h1
              className="text-xl md:text-2xl font-semibold
          text-white text-center md:text-left"
            >
              Student Stats
            </h1>
            <hr className="bg-purple-600 h-0.5 border-none" />
            <p className="text-sm font-medium text-white text-center">
              Öğrenci Verileri
            </p>
          </div>

          <div className="flex justify-center gap-2 sm:gap-6 md:gap-8 w-full md:w-auto">
            {levelSet.map((level) => {
              const isExit = level.name === "Exit" || level.name === "Exıt";
              const isActive = activeLevel === level.name;

              return (
                <button
                  key={level.name}
                  onClick={() => handleLevelChange(level.name)}
                  className={`px-2 py-2 md:px-4 text-sm md:text-base  
                font-semibold transition-all rounded-lg group
                ${
                  isExit
                    ? // 🔴 Exit butonu (kırmızı)
                      isActive
                      ? "bg-red-600 text-white shadow-md"
                      : "text-red-500  hover:bg-red-600 hover:text-white"
                    : // 🟣 Diğer butonlar
                      isActive
                      ? "bg-purple-500 text-white shadow-md"
                      : "text-white hover:bg-purple-500"
                }`}
                >
                  <p>{level.name}</p>
                  <hr
                    className={`border-b-2 transition-colors ${
                      isExit
                        ? isActive
                          ? "border-red-400"
                          : "border-red-500 group-hover:border-red-400"
                        : isActive
                          ? "border-yellow-500"
                          : "border-purple-500 group-hover:border-yellow-500"
                    }`}
                  />
                  <p className="text-sm font-medium">{level.tr}</p>
                </button>
              );
            })}
          </div>
        </div>
      </div>
      <div
        className="flex-1 flex flex-col  h-full 
         gap-5 p-4 bg-white rounded-2xl"
      >
        {activeLevel === "Chapters" && (
          <div className="flex flex-col gap-4">
            <div
              className="flex gap-4 items-center bg-gray-100 p-2 rounded-xl
            overflow-x-auto overflow-y-hidden flex-nowrap scrollbar-thin"
            >
              {activeClass.length > 0 ? (
                activeClass.map((item, index) => {
                  const percentage = Math.round(
                    (item.completedtask / item.totalUnites) * 100,
                  );
                  const isSelected = selectedUnit === item.unites;

                  return (
                    <div
                      key={index}
                      onClick={() => handleSelectChapter(item.unites)}
                      className={`group cursor-pointer transition-all duration-300 hover:scale-105 ${
                        isSelected ? "scale-105" : ""
                      }`}
                    >
                      <div
                        className={`flex justify-start items-center gap-3 p-4 rounded-xl ${
                          isSelected
                            ? "bg-purple-500 shadow-xl"
                            : "bg-gray-100 shadow-md hover:shadow-lg"
                        }`}
                      >
                        <div className="relative">
                          <button
                            className={`relative w-12 h-12 flex flex-col items-center justify-center
                            rounded-full text-white transition-all duration-300 ${
                              isSelected
                                ? "bg-yellow-500"
                                : "bg-gradient-to-br from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700"
                            }`}
                          >
                            <span className="text-lg">
                              {item.completedtask}
                            </span>
                            <hr className="border border-white w-6" />
                            <span className="text-xs opacity-75">
                              {item.totalUnites}
                            </span>
                          </button>
                        </div>

                        <div className="flex flex-col gap-1">
                          <p className="text-sm text-gray-800 text-center max-w-[120px] leading-tight">
                            {TaskName(item.unites) || `Kategori ${index + 1}`}
                          </p>
                          <div className="w-full bg-gray-200 rounded-full h-1.5">
                            <div
                              className={`h-1.5 rounded-full transition-all duration-500 ${
                                percentage === 100
                                  ? "bg-green-500"
                                  : percentage >= 50
                                    ? "bg-yellow-500"
                                    : "bg-gray-400"
                              }`}
                              style={{ width: `${percentage}%` }}
                            ></div>
                          </div>
                        </div>
                      </div>

                      <div
                        className={`ml-40 -mt-5 w-8 h-8 rounded-full flex items-center
                            justify-center text-xs font-bold shadow-md z-60 
                            opacity-0 group-hover:opacity-100 transition-opacity duration-200 ${
                              percentage === 100
                                ? "bg-green-500 text-white"
                                : percentage >= 50
                                  ? "bg-yellow-500 text-white text-[10px] font-normal"
                                  : "bg-yellow-500 text-white text-[10px] font-normal"
                            }`}
                      >
                        {percentage}%
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="col-span-3 text-center p-8 bg-gray-100 rounded-lg w-full">
                  <p className="text-gray-600">Henüz kategori bulunmuyor.</p>
                </div>
              )}
            </div>
            <StudentChapter
              selectedUnit={selectedUnit}
              completedChapter={completedChapter}
              allChapter={allChapter}
              TaskName={TaskName}
              studentForId={studentForId}
            />
          </div>
        )}

        {activeLevel === "Homeworks" && (
          <div className="p-4 bg-blue-100 rounded-lg">
            <h2 className="text-2xl font-bold mb-4">Ödevler</h2>
            <p>Ödevler içeriği burada gösterilecek.</p>
          </div>
        )}

        {activeLevel === "Extras" && (
          <div className="flex flex-col gap-4">
            <div
              className="flex gap-4 items-center bg-gray-100 p-2 rounded-xl
            overflow-x-auto overflow-y-hidden flex-nowrap scrollbar-thin"
            >
              {activeExtra.length > 0 ? (
                activeExtra.map((item, index) => {
                  const percentage = Math.round((item.puan / 4) * 100);
                  const isSelected = selectedExtra === item.name;
                  return (
                    <div
                      key={index}
                      onClick={() => handleSelectExtra(item.name)}
                      className={`group cursor-pointer transition-all duration-300 hover:scale-105 ${
                        isSelected ? "scale-105" : ""
                      }`}
                    >
                      <div
                        className={`flex justify-start items-center gap-3 p-4 rounded-xl ${
                          isSelected
                            ? "bg-purple-500 shadow-xl"
                            : "bg-gray-100 shadow-md hover:shadow-lg"
                        }`}
                      >
                        <div className="relative">
                          <button
                            className={`relative w-12 h-12 flex flex-col items-center justify-center
                            rounded-full text-white transition-all duration-300 ${
                              isSelected
                                ? "bg-yellow-500"
                                : "bg-gradient-to-br from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700"
                            }`}
                          >
                            <span className="text-lg">{item.puan}</span>
                            <hr className="border border-white w-6" />
                            <span className="text-xs opacity-75">4</span>
                          </button>
                        </div>

                        <div className="flex flex-col gap-1">
                          <p className="text-sm text-gray-800 text-center max-w-[120px] leading-tight">
                            {TaskName(item.title) || `Kategori ${index + 1}`}
                          </p>
                          <div className="w-full bg-gray-200 rounded-full h-1.5">
                            <div
                              className={`h-1.5 rounded-full transition-all duration-500 ${
                                percentage === 100
                                  ? "bg-green-500"
                                  : percentage >= 50
                                    ? "bg-yellow-500"
                                    : "bg-gray-400"
                              }`}
                              style={{ width: `${percentage}%` }}
                            ></div>
                          </div>
                        </div>
                      </div>

                      <div
                        className={`ml-40 -mt-5 w-8 h-8 rounded-full flex items-center
                            justify-center text-xs font-bold shadow-md z-60 
                            opacity-0 group-hover:opacity-100 transition-opacity duration-200 ${
                              percentage === 100
                                ? "bg-green-500 text-white"
                                : percentage >= 50
                                  ? "bg-yellow-500 text-white text-[10px] font-normal"
                                  : "bg-yellow-500 text-white text-[10px] font-normal"
                            }`}
                      >
                        {percentage}%
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="col-span-3 text-center p-8 bg-gray-100 rounded-lg w-full">
                  <p className="text-gray-600">Henüz kategori bulunmuyor.</p>
                </div>
              )}
            </div>
            <ExtraChapter studentForId={studentForId} />
          </div>
        )}
      </div>
    </div>
  );
}

export default StudentDetail;
